<div *ngIf="!book">
  <app-loading-spinner></app-loading-spinner>
</div>
<div *ngIf="book">
  <app-navbar></app-navbar>
  <button (click)="back()" class=" btn btn-block mt-1 p-2 btn-danger">
    Back
  </button>
  <div class="jumbotron text-center">
    <h4 class="card-title h4 pb-2">
      <strong> Book Title : {{ book.title }}</strong>
    </h4>
    <div class="view overlay my-4 waves-light text-center " mdbWavesEffect>
      <img
        [src]="book.image"
        height="250"
        width="300"
        class="img-fluid"
        alt=""
      />
      <a>
        <div class="mask rgba-white-slight"></div>
      </a>
    </div>

    <h5 class="h5 mb-4">BookRate : {{ book.rate }}</h5>

    <h5>
      Book Description :
    </h5>

    <p class="card-text">{{ book.description }}</p>
    <div p-3 class="text-center mb-3">
      <div
        mdbModal
        #frame="mdbModal"
        class="modal fade"
        id="frameModalTop"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
        (open)="onOpen()"
      >
        <div class="modal-dialog modal-notify modal-danger" role="document">
          <!--Content-->
          <div class="modal-content">
            <!--Header-->
            <div class="modal-header">
              <p class="heading lead">Vote Book</p>

              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                (click)="frame.hide()"
              >
                <span aria-hidden="true" class="white-text">&times;</span>
              </button>
            </div>

            <!--Body-->
            <div class="modal-body">
              <div *ngIf="isVoted" class="text-center alert alert-success ">
                book voted
              </div>
              <div *ngIf="!isVoted" class="text-center alert alert-danger ">
                book not voted
              </div>
              <div *ngIf="isOnList" class="text-center alert alert-success ">
                book added to reading list
              </div>
              <div *ngIf="!isOnList" class="text-center alert alert-danger ">
                book remove to reading list
              </div>
              <div *ngIf="isfav" class="text-center alert alert-success">
                book Add to Favorite Books
              </div>
              <div *ngIf="!isfav" class="text-center alert alert-danger ">
                book Remove Form Favorite Books
              </div>
            </div>

            <!--Footer-->
            <div class="modal-footer justify-content-center">
              <a
                type="button"
                mdbBtn
                color="primary"
                class="waves-light"
                mdbWavesEffect
                (click)="frame.hide()"
              >
                save changes
                <mdb-icon fas icon="check" class="ml-1"></mdb-icon>
              </a>
              <a
                type="button"
                mdbBtn
                color="primary"
                outline="true"
                class="waves-effect"
                mdbWavesEffect
                (click)="frame.hide()"
                data-dismiss="modal"
                >cancel</a
              >
            </div>
          </div>
        </div>
      </div>

      <i
        (click)="voted(id); frame.show()"
        [class]="book.isVoted ? 'fas fa-thumbs-up' : 'far fa-thumbs-up'"
        style="font-size: 35px; margin: 0 10px;"
      ></i>
      <i
        (click)="fav(id); frame.show()"
        [class]="book.isfav ? 'fas fa-heart' : 'far fa-heart'"
        style="font-size: 35px; margin: 0 10px;"
      ></i>
      <i
        (click)="reading(); frame.show()"
        [class]="isOnList ? 'fas fa-calendar-plus' : 'far fa-calendar-plus'"
        style="font-size: 35px; margin: 0 10px;"
      ></i>
    </div>
  </div>

  <div class="container section-top offset-md-2">
    <h3>users reviews</h3>
    <div class="mt-5 col-md-12 offset-md-2">
      <div class="row">
        <div class="col-lg-10 col-xl-8">
          <div class="media d-block d-md-flex mb-2">
            <img
              class="d-flex rounded-circle avatar z-depth-1-half mb-3 mx-auto"
              src="https://mdbootstrap.com/img/Others/documentation/img (20)-mini.jpg"
              alt="Avatar"
            />
            <div class="media-body text-center text-md-left ml-md-3 ml-0">
              <h5 class="mt-0 font-weight-bold blue-text">Anna Smith</h5>
              Cras sit amet nibh libero, in gravida nulla. Nulla vel metus
              scelerisque ante sollicitudin. Cras purus odio, vestibulum in
              vulputate at, tempus viverra turpis. Fusce condimentum nunc ac
              nisi vulputate fringilla. Donec lacinia congue felis in faucibus.

              <div class="media d-block d-md-flex mt-3 shadow-textarea mb-2">
                <img
                  class="d-flex rounded-circle avatar z-depth-1-half mb-3 mx-auto"
                  src="https://mdbootstrap.com/img/Others/documentation/img (3)-mini.jpg"
                  alt="Generic placeholder image"
                />
                <div class="media-body text-center text-md-left ml-md-3 ml-0">
                  <h5 class="mt-0 font-weight-bold blue-text mb-3">
                    Danny Tatuum
                  </h5>
                  <div
                    class="form-group basic-textarea rounded-corners mb-md-0 mb-4"
                  >
                    <textarea
                      class="form-control z-depth-1"
                      id="exampleFormControlTextarea3"
                      rows="3"
                      placeholder="Write your comment..."
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="media d-block d-md-flex">
            <img
              class="d-flex rounded-circle avatar z-depth-1-half mb-3 mx-auto"
              src="https://mdbootstrap.com/img/Others/documentation/img (2)-mini.jpg"
              alt="Avatar"
            />
            <div class="media-body text-center text-md-left ml-md-3 ml-0">
              <h5 class="mt-0 font-weight-bold blue-text">Caroline Horwitz</h5>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corporis
              odit minima eaque dignissimos recusandae officiis commodi nulla
              est, tempore atque voluptas non quod maxime, iusto, debitis
              aliquid? Iure ipsum, itaque.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-recently-added
    [title]="'You May like to read '"
    [cards]="books"
  ></app-recently-added>
  <app-footer></app-footer>
</div>
